import ColorPicker from './color-picker.vue';

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/color-picker/index.js